module.exports = __webpack_public_path__ + "static/media/switchBusiness.2a87e6c2.svg";